import { differenceInMinutes } from "date-fns";
import { useEffect, useState } from "react";

interface UseMinuteCountdownOptions {
  date: Date;
}

export function useMinuteCountdown({ date }: UseMinuteCountdownOptions) {
  const [liveLeadTime, setLiveLeadTime] = useState(() => differenceInMinutes(date, new Date()));

  useEffect(() => {
    const updateLeadTime = () => {
      setLiveLeadTime(differenceInMinutes(date, new Date()));
    };

    // Update immediately
    updateLeadTime();

    // Set up interval to update every minute (60000ms)
    const interval = setInterval(updateLeadTime, 60_000);

    return () => {
      clearInterval(interval);
    };
  }, [date]);

  return liveLeadTime;
}
